export default {
  login_google: { id: 'login_google' },
}
